import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about">
      <div className="section-hero">
        <div className="prlx-bg" style={{ backgroundImage: `url('/assets/images/sustaira-partner-ecosystem-gi1337590442-feature-500x500.jpeg')` }}></div>
        <div className="prlx-overlay"></div>
        <div className="prlx-overlay-gold"></div>
        <div className="sh-content">
          <div className="sh-label">Who We Are</div>
          <h2 className="sh-title">About <em>Profibercom</em></h2>
        </div>
      </div>

      <div className="sec about-sec">
        <div className="sec-inner">
          <div className="about-grid">
            <div className="about-imgs reveal-left">
              <div className="about-main-img">
                <img src="/assets/images/Drawing-104.jpeg" alt="Mining operations" />
              </div>
              <div className="about-accent-img">
                <img src="/assets/images/software-improvement-group-feature-500x500.jpeg" alt="Control panel" />
              </div>
              <div className="about-tag">Trusted Partner</div>
            </div>
            
            <div className="reveal-right">
              <div className="sec-label">About Profibercom</div>
              <h2 className="sec-title">Bridging Mechanical Operations & <em>Intelligent Monitoring</em></h2>
              <div className="divider"></div>
              <p className="sec-desc">Profibercom (Pty) Ltd is a premier engineering and technology solutions provider established to meet the rigorous demands of heavy industries. With a strong foundation in both fiber optic technology and industrial electronic safeguards, we deliver end-to-end solutions — from high-speed communication backbones to intelligent conveyor protection systems.</p>
              
              <div className="about-feats">
                <div className="about-feat reveal">
                  <div className="feat-ico">🎯</div>
                  <div className="feat-txt">
                    <h4>Our Vision</h4>
                    <p>To be the leading industrial technology partner in Africa, driving innovation in safety, control systems, and telecommunications.</p>
                  </div>
                </div>
                <div className="about-feat reveal">
                  <div className="feat-ico">⚡</div>
                  <div className="feat-txt">
                    <h4>End-to-End Solutions</h4>
                    <p>From high-speed communication backbone installation to deployment of intelligent conveyor protection systems.</p>
                  </div>
                </div>
                <div className="about-feat reveal">
                  <div className="feat-ico">🛡️</div>
                  <div className="feat-txt">
                    <h4>Safety First, Always</h4>
                    <p>All systems operate within optimal safety parameters, delivering real-time data to operators and management.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;